/**
 * @module Split Section - Column Content
 * @description Column Content
 */
import ColumnContent from '@/blocks/ColumnContent';
import Tooltip from '@/blocks/Tooltip';

/**
* @function Component
* @description
*/
const Component = () => (
  <ColumnContent
    headline="Do more faster"
    subhead="The Wi-Fi you've been waiting for"
    copy={ <>Work, live and play the way you want with Frontier<sup>&reg;</sup> Fiber.</> }
    theme="dark"
    useTiles
    items={ [
      {
        icon: 'cloud-upload',
        headline: 'Super fast sharing',
        content: 'Share as fast as you can stream on multiple devices at the same time.'
      },
      {
        icon: 'home-wifi',
        headline: 'Whole-Home Wi-Fi',
        content: <><span>Add up to two extenders to get the most out of your internet.</span><span data-legal="whole-home-wifi" /></>
      },
      {
        icon: 'global-wifi',
        headline: 'Unlimited access',
        content: <><span>Unlock everything the internet has to offer with unlimited data and no overage charges.</span><Tooltip disclosure="data-caps" placement="top" /></>
      }
    ] }
  />
);

export default Component;
